import {useEffect, useRef} from 'react'
import {Pagination, useListPaginationContext} from 'react-admin'

import useSearchParams from '../../hooks/useSearchParams'

const ExtendedPagination = ({...props}) => {
  useRestorePaginationPageFromSearchParams()
  return (
    <Pagination limit={null as any} {...props} />
  )
}

const useRestorePaginationPageFromSearchParams = () => {
  const {setPage} = useListPaginationContext()
  const {searchParams: {page: searchParamPage}} = useSearchParams()
  const isRestored = useRef(false)
  useEffect(() => {
    if (isRestored.current || !searchParamPage) return
    setPage(Number(searchParamPage))
    const timeoutId = setTimeout(() => {isRestored.current = true}, 0)
    return () => clearTimeout(timeoutId)
  }, [searchParamPage, setPage])
}

export default ExtendedPagination
